<div class="container-fluid spacer-top-navigation savings-plan" [zeroLoadingIndicator]="facade.confirmSavingsPlans$ | async">
  <div class="container mb-3">
    <div class="row row--primary">
      <div class="col-12 pl-0 mb-2 d-flex align-items-center">
        <a (click)="goBack.emit()" class="link-secondary font-default cursor-pointer">
          <svg class="icon icon-21"><use xlink:href="/assets/img/svgs/svgset.svg#arrow-left" /></svg>
          {{ 'savings-plan.check-savings-plan.back' | transloco }}
        </a>
      </div>
    </div>
    <div class="row row--primary d-block tile">
      <div class="col-12 pl-0 pr-0">
        <div class="row">
          <div class="col-12 mb-4">
            @if (facade.isMultiSavingsPlanOrder$ | async) {
              <h1 class="zero-text p-bigger-bold">{{ 'savings-plan.check-savings-plan.headline-multi' | transloco }}</h1>
            } @else {
              <h1 class="zero-text p-bigger-bold">{{ 'savings-plan.check-savings-plan.headline' | transloco }}</h1>
            }
          </div>
          <div class="col mb-3 font-medium">
            {{ 'savings-plan.check-savings-plan.hint' | transloco }}
          </div>
        </div>
        <hr class="less-margin" />
        <div class="row">
          <div class="col-sm-5">
            {{ 'savings-plan.savings-plan-summary.type' | transloco }}
          </div>
          <div class="col-sm-7 font-medium text-sm-right">
            {{ 'savings-plan.savings-plan-summary.type-value' | transloco }}
          </div>
        </div>
        <hr class="less-margin" />
        <div class="row">
          <div class="col-12 mb-4">
            @if (facade.multiSavingsPlans$ | async; as savingsPlans) {
              @if (savingsPlans.length > 1) {
                {{ 'savings-plan.savings-plan-summary.multi-instrument' | transloco }}
              } @else {
                {{ 'savings-plan.savings-plan-summary.instrument' | transloco }}
              }
            } @else if (facade.savingsPlanToUpdate$ | async) {
              {{ 'savings-plan.savings-plan-summary.instrument' | transloco }}
            }
          </div>
          <div class="col-12 pl-4 pr-4">
            <saving-plans-confirm-assets />
          </div>
        </div>
        <hr class="less-margin" />
        <div class="row">
          <div class="col-sm-5">
            {{ 'savings-plan.savings-plan-summary.first-execution' | transloco }}
          </div>
          <div class="col-sm-7 text-sm-right font-medium">
            {{ facade.execDate$ | async | date: 'shortDate' : 'UTC +2' }}
          </div>
        </div>
        <hr class="less-margin" />
        <div class="row">
          <div class="col-sm-5">
            {{ 'savings-plan.savings-plan-summary.interval' | transloco }}
          </div>
          <div data-zid="savings-plan-interval" class="col-sm-7 text-sm-right font-medium">
            {{ 'savings-plan.savings-plan-form.interval.' + (facade.interval$ | async) | transloco }}
          </div>
        </div>
        <hr class="less-margin" />
        <div class="row">
          <div class="col-sm-5">
            {{ 'savings-plan.savings-plan-summary.dynamization' | transloco }}
          </div>
          <div data-zid="savings-plan-dynamization" class="col-sm-7 text-sm-right font-medium">
            @if (facade.dynamization$ | async; as dynamization) {
              {{ dynamization }} % p.a.
            } @else {
              &mdash;
            }
          </div>
        </div>
        <hr class="less-margin" />
        <div class="row">
          <div class="col-sm-5 col-md-7">
            {{ 'savings-plan.savings-plan-summary.served-by' | transloco }}
          </div>
          <div class="col-sm-7 col-md-5 text-sm-right">
            <div class="zero-text p-base-reg link link-secondary" (click)="handleServedByChange()">
              @if (sepaFacade.selectedOption$ | async; as option) {
                {{ option.label | transloco }} <web-design-system-icon name="refresh" />
              }
            </div>
          </div>
          @if (sepaFacade.errorMessage$ | async; as msg) {
            <div class="col-12 mt-2 zero-text course-red">{{ msg }}</div>
          }
        </div>
        @if (facade.multiSavingsPlanSum$ | async; as sum) {
          <hr class="less-margin" />
          <div class="row">
            <div class="col-sm-5">
              {{ 'savings-plan.savings-plan-summary.sum' | transloco }}
            </div>
            <div class="col-sm-7 text-sm-right font-medium">
              {{ sum | currency }}
            </div>
          </div>
        }
        <saving-plans-confirm-config-items />
        <hr class="less-margin" />
        <div class="row mt-4">
          <div class="col-12">
            <web-components-trading-session (authorizationState)="hasTradingSession = $event" />
          </div>
        </div>
        <saving-plans-errors />
        <div class="row mt-4 mb-2">
          <div class="col">
            <web-design-system-button
              data-zid="savings-plan-confirm"
              [fullwidth]="true"
              [disabled]="!hasTradingSession"
              (click)="confirm.emit()"
            >
              @if (facade.multiSavingsPlans$ | async; as savingsPlans) {
                @if (savingsPlans.length > 1) {
                  {{ 'savings-plan.savings-plan-summary.submit-multiple' | transloco: { count: savingsPlans.length } | uppercase }}
                } @else {
                  {{ 'savings-plan.savings-plan-summary.submit' | transloco | uppercase }}
                }
              }
            </web-design-system-button>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <a class="link-secondary cursor-pointer" (click)="goBack.emit()">
              {{ 'trade.multi-order.confirm.cancel' | transloco }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
